import { render, staticRenderFns } from "./product-search-bar.vue?vue&type=template&id=4bfe18ac&scoped=true&"
import script from "./product-search-bar.vue?vue&type=script&lang=js&"
export * from "./product-search-bar.vue?vue&type=script&lang=js&"
import style0 from "./product-search-bar.vue?vue&type=style&index=0&id=4bfe18ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfe18ac",
  null
  
)

export default component.exports